import { render, staticRenderFns } from "./PlyrCSSOverride.vue?vue&type=template&id=d5fe41f2&lang=html&"
import script from "./PlyrCSSOverride.vue?vue&type=script&lang=js&"
export * from "./PlyrCSSOverride.vue?vue&type=script&lang=js&"
import style0 from "./PlyrCSSOverride.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports